import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import CreditNote from '../../entities/sales/creditnote'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'
import url from '../../../lib/url'
import CreditNoteDetail from '@/store/entities/sales/creditnotedetail';
import CreditNoteHistory from '@/store/entities/sales/history';
import Sale from '@/store/entities/sales/sale';
import PageResult from '@/store/entities/page-result';
import axios from 'axios'

interface CreditNoteState extends ListState<CreditNote>{
    editModel: CreditNote;
    hisLoading: boolean;      
    history: Array<CreditNoteHistory>;
    reportList: Array<any>;
    customer: number;
    sale: Sale;
    filename: string;    
}
class CreditNoteModule extends ListModule<CreditNoteState,any,CreditNote>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<CreditNote>(),
        loading:false,
        hisLoading:false,
        editModel: new CreditNote(),
        activeList: new Array<CreditNote>(),
        history: new Array<CreditNoteHistory>(),
        customer: 0,
        sale: new Sale(),
        reportList: new Array<any>(),
        filename: '',
        path: 'credit-notes'         
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
        async getAll(context: ActionContext<CreditNoteState, any>, payload: any) {
            if (context.state.loading) return context.state.list;
            context.state.loading = true;
            if (context.state.customer != null && context.state.customer > 0)
                payload.data.for_customer = context.state.customer;
            let reponse = await Ajax.get('/api/' + (context.state as any).path, { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            if (typeof reponse.data.result == 'object' && !Array.isArray(reponse.data.result)) {
                let page = reponse.data.result as PageResult<CreditNote>;
                context.state.totalCount = page.total;
                context.state.list = page.data;
            } else {
                context.state.totalCount = reponse.data.result.length;
                context.state.list = reponse.data.result;
            }
            return context.state.list;
        },
        async update(context: ActionContext<CreditNoteState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.put('/api/' + (context.state as any).path + '/' + payload.data.id, payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            context.state.editModel = response.data.result;
            return response.data.result;
        },
        async invoice(context: ActionContext<CreditNoteState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.post('/api/credit-note-invoice', payload.data).catch(e => {
                context.state.loading = false;
                return false;
            });
            context.state.loading = false;
            if (!response)
                return response;
            else if ((response as any).data != undefined)
                return (response as any).data.result;
            return false;
        },
        async cancel(context: ActionContext<CreditNoteState, any>, payload: any) {
            context.state.loading = true;
            await Ajax.post('/api/credit-notes/cancel', { id: payload.data.id, cancel_reason: payload.data.cancel_reason }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
        },
        async getHistory(context: ActionContext<CreditNoteState, any>, payload: any) {
            context.state.hisLoading = true; 
            let id = context.state.editModel.id;
            let reponse = await Ajax.get('/api/credit-notes/' + id + '/history', { params: { id: id } }).catch(e => {
                context.state.hisLoading = false;
                return Promise.reject(e);
            });
            context.state.history = reponse.data.result;
            context.state.hisLoading = false;
        },
        async print(context: ActionContext<CreditNoteState, any>, payload: any) {
            context.state.loading = true;

            let format = Util.abp.setting.get('SALES_PRINT_FORMAT');
            let localUrl = Util.abp.setting.get('LOCAL_PRINTER_URL');
            let mode = Util.abp.setting.get('REMOTE_PRINTER_MODE');
            let method = Util.abp.setting.get('REMOTE_PRINTER_METHOD');
            let useRemote = Util.abp.setting.get('USE_REMOTE_PRINTER');
            let api = (format == 'A4' ? 'credit-note-invoice' : 'credit-note-invoice-receipt');

            let response = await Ajax.get('/api/' + api, { params: { id: payload.id } }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;

            if (mode == 'LOCAL' && useRemote == 1 && format == 'TK') {
                if (response.data.result.localUrl != undefined) localUrl = response.data.result.localUrl;
                if (method == 'POST') {
                    await axios.post(localUrl, response.data.result);
                } else {
                    let href: any = localUrl + "?endpoint=" + (url + 'api/' + api) + "&token=" + window.abp.auth.getToken() + "&id=" + payload.id;
                    const link = document.createElement('a');
                    link.href = href;
                    link.target = '_blank';
                    document.body.appendChild(link);
                    link.click();
                    return '';
                    //await axios.get(localUrl, { params: response.data.result });
                }
                return '';
            } else
                return response.data.result; 
        },
        async downloadInvoiceFile(context: ActionContext<CreditNoteState, any>, payload: any) {
            let enableNube = Util.abp.setting.get('NUBEFACT_EINVOICE_ENABLE');
            let enableSunat = Util.abp.setting.get('SUNAT_EINVOICE_ENABLE');
            context.state.loading = true;
            payload.data.credit = payload.data.id;
            let data = { params: payload.data };
            if (enableSunat == 1) data['responseType'] = 'blob';
            let reponse = await Ajax.get('/api/sale-invoices-download', data).then(response => {
                const link = document.createElement('a');
                if (enableNube == 1) {
                    const url = response.data.result;
                    link.href = url;
                    if (payload.data.type == 'pdf')
                        link.target = '_blank';
                } else if (enableSunat == 1) {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    link.href = url;
                }
                link.setAttribute('download', payload.data.filename); //or any other extension
                document.body.appendChild(link);
                link.click();
            }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
        },        
        async reportCreditNotes(context: ActionContext<CreditNoteState, any>, payload: any) {
            context.state.loading = true;
            context.state.reportList = [];
            let reponse = await Ajax.get('/api/reports/credit-notes', { params: payload.data }).catch(e => {
                context.state.loading = false;
                context.state.filename = '';
                return Promise.reject(e);
            });
            context.state.reportList = reponse.data.result.list;
            context.state.filename = reponse.data.result.url;
            context.state.loading = false;
        },
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
        new(state: CreditNoteState, model: CreditNote) {
            state.sale = null;
            state.editModel = Object.assign({});
            state.editModel.process_date = Util.abp.clock.today();
            state.editModel.currency_id = Util.abp.setting.get('DEFAULT_CURRENCY');
            state.editModel.currency_sign = 'S/';
            state.editModel.exchange_rate = 1;
            state.editModel.invoice_type_name = 'Nota de Credito';
            state.editModel.subtotal = 0.00;
            state.editModel.subtotal_wt = 0.00;
            state.editModel.taxes = 0.00;
            state.editModel.total = 0.00;
            state.editModel.total_wt = 0.00;
            state.editModel.used_amount = 0.00;
            state.editModel.discounts = 0.00;            
            state.editModel.balance = 0.00;
            state.editModel.invoice_serie = null;
            state.editModel.invoice_number = '0';
            state.editModel.details = new Array<CreditNoteDetail>();
        },
        edit(state: CreditNoteState, model: CreditNote) {
            state.editModel = model;
            state.editModel.currency_sign = model.currency.sign;
            state.editModel.invoice_type_name = 'Nota de Credito';
            state.editModel.sale_invoice_type = model.sale_invoice_type;

            state.editModel.customer_code = model.customer.code;
            state.editModel.customer_document = model.customer.document_full;
            state.editModel.customer_name = model.customer.fullname;
            state.editModel.customer_address = model['address_full'];
        },
        setInvoiceNumber(state: CreditNoteState, number: any) {
            state.editModel.invoice_number = number;
        },
        updateAmount(state: CreditNoteState, details: Array<CreditNoteDetail>) {
            state.editModel.subtotal = 0;
            state.editModel.subtotal_wt = 0;
            state.editModel.taxes = 0;
            
            details.forEach((item, index) => {
                state.editModel.subtotal += item.total;
                state.editModel.subtotal_wt += item.total_wt;
            });

            state.editModel.total = state.editModel.subtotal;
            state.editModel.total_wt = state.editModel.subtotal_wt;
            state.editModel.taxes = state.editModel.total_wt - state.editModel.total;
            state.editModel.balance = state.editModel.total_wt + state.editModel.used_amount;
        },
        setTotals(state: CreditNoteState, data: any) {
            state.editModel.subtotal = data.subtotal;
            state.editModel.subtotal_wt = data.subtotal_wt;
            state.editModel.taxes = data.taxes;
            state.editModel.total = data.total;
            state.editModel.total_wt = data.total_wt;
            state.editModel.balance = data.balance;
            state.editModel.used_amount = data.used_amount;
        },
        loadFromSale(state: CreditNoteState, model: Sale) {
            var today = new Date();
            var tomorrow = new Date();
            tomorrow.setDate(today.getDate() + 7);

            let reason = state.editModel.reason_id;
            state.sale = model;
            state.editModel = Object.assign({});
            state.editModel.customer_code = model.customer.code;
            state.editModel.customer_document = model.customer.document_full;
            state.editModel.customer_name = model.customer.fullname;
            state.editModel.customer_address = model.address_full;

            state.editModel.reason_id = reason;
            state.editModel.reference = model.reference;
            state.editModel.sale_id = model.id;
            state.editModel.process_date = Util.abp.clock.today();
            state.editModel.customer_id = model.customer_id;
            state.editModel.currency = model.currency;
            state.editModel.currency_id = model.currency_id;
            state.editModel.invoice_type_name = 'Nota de Credito';
            state.editModel.sale_invoice_type = model.invoice_type_id;
            state.editModel.sale_invoice = (model as any).invoice;
            state.editModel.currency_sign = model.currency.sign;
            state.editModel.exchange_rate = model.exchange_rate;
            state.editModel.subtotal = model.subtotal;
            state.editModel.subtotal_wt = model.subtotal_wt;
            state.editModel.taxes = model.taxes;
            state.editModel.discounts = model.discounts;            
            state.editModel.total = model.total;
            state.editModel.total_wt = model.total_wt;
            state.editModel.balance = model.total_wt;
            state.editModel.invoice_serie = null;
            state.editModel.invoice_number = '0';
            state.editModel.details = new Array<CreditNoteDetail>();

            model.details.forEach((item, index) => {
                if ((item.quantity - item.quantity_returned) > 0) {
                    let det = new CreditNoteDetail();
                    det.credit_note_id = state.editModel.id;
                    det.id = item.id;
                    det.sale_detail_id = item.id;
                    det.product_id = item.product_id;
                    det.warehouse_id = item.warehouse_id;
                    det.unity_id = item.unity_id;
                    det.code = item.code;
                    det.product_name = item.product_name;
                    det.quantity = (item.quantity - item.quantity_returned);
                    det.price = item.price;
                    det.price_wt = item.price_wt;
                    det.total = item.total;
                    det.total_wt = item.total_wt;
                    det.taxes = item.taxes;
                    det.discounts = 0;
                    det.stock = (item.quantity - item.quantity_returned);
                    det.service = item.service;
                    det.gift = item.gift;
                    state.editModel.details.push(det);
                }
            });
            
        },
        setCustomer(state: CreditNoteState, id: number) {
            state.customer = id;
        },
    });
}
const creditnoteModule=new CreditNoteModule();
export default creditnoteModule;